import { Component } from '@angular/core';

@Component({
  selector: 'rt-impact-tracker-hexagons',
  templateUrl: './hexagons.component.html',
})
export class HexagonsComponent {}
